import { render, staticRenderFns } from "./Favorites.vue?vue&type=template&id=22e2f697&scoped=true&"
import script from "./Favorites.vue?vue&type=script&lang=ts&"
export * from "./Favorites.vue?vue&type=script&lang=ts&"
import style0 from "./Favorites.vue?vue&type=style&index=0&id=22e2f697&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e2f697",
  null
  
)

export default component.exports